// packages/app/src/scaffolder/ServiceKeyPicker.tsx
//
// Custom field extension for serviceKey validation. The validation rule
// itself lives in ./serviceKeyValidation.ts, mirrored from the backend's
// validateServiceKey — see that file for details.

import { useState } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { serviceKeyMaxLength, validateServiceKey as validate } from './serviceKeyValidation';

export const ServiceKeyPickerComponent = ({
  onChange,
  rawErrors,
  required,
  formData,
  formContext,
  schema,
}: FieldExtensionComponentProps<string>) => {
  const [touched, setTouched] = useState(false);

  // Read sibling applicationKey value from the full form context
  const appKey: string = (formContext as any)?.formData?.applicationKey ?? '';

  const dynamicError = touched ? validate(formData ?? '', appKey) : null;
  const hasError = (rawErrors?.length ?? 0) > 0 || !!dynamicError;

  const maxLength = serviceKeyMaxLength(appKey);
  const helperText = dynamicError
    ?? (hasError ? rawErrors?.[0] : null)
    ?? (appKey
      ? `Max ${maxLength} chars (app key "${appKey}" uses ${appKey.length}). e.g. dt-payment-prc-api`
      : 'Lowercase letters, numbers and hyphens only. Example: dt-payment-prc-api');

  return (
    <FormControl required={required} error={hasError} fullWidth>
      <TextField
        label={schema?.title ?? 'Service Key'}
        value={formData ?? ''}
        required={required}
        error={hasError}
        helperText={helperText}
        inputProps={{ spellCheck: false }}
        onChange={e => {
          setTouched(true);
          onChange(e.target.value);
        }}
        onBlur={() => setTouched(true)}
      />
    </FormControl>
  );
};
